/**
 * Apollo Client の共通化モジュール
 */
import { ApolloClient, from } from "@apollo/client";
import { useMemo } from "react";
import { cache } from "./cache";
import { errorLink, httpLink, responseLink } from "~/lib/apollo/link";
import { isBot } from "~/util/is-bot";

export const apolloClient = new ApolloClient({
  ssrMode: isBot(),
  connectToDevTools: false,
  link: from([responseLink, errorLink, httpLink]),
  cache,
});

export const useApolloClient = () => {
  return useMemo(() => apolloClient, []);
};
